var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilityimprovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_109_9472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_109_9472",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_9472",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_9472",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACgElEQVR4nO3cPWtUQRTG8THESBS0sUhiYaWVliIWYuMH0MLW0o/g2mirICj4grG1tLW0URTEUiyMvYngu6JiFPzLwIABb9RwZ+acO/f5wcIWh52d5y4zc8/CDUFERERE1gDmgOvA2/SK7+fX1kgPwDZgAnzkT1+AC8COPmOMGjANnAJe8m9v0sXYYv29BwU4Cjxl454DJ4BN1nNwDTgI3Ke/x8AR6/m4A+wFbgM/yesusD+MHbAzbWarlPMDuDnKEwp/P0mU8jld1O2hdcAUcBJYwc7rdJFnQouAY8CzHgHF5eU0sJBek55LzhJwPLQCOAQ8oL9Jx2fHsPt6GL9jGKoCJ4n5dW7Lc55Q9oUBniS+kddCx1i7Cp1Q5oLzk8RZ4BNlTDrGPFNorDiHc3FOwWFPovRJYjWtybk2w/+xkuY27aEn8YT2LZn0UIADwD3G5xFwuEbAu4FbBXoSQ3MH2FMi4BngMvDdeoaOxCwuAZtzBh0/ULpdzBl0/AdDur3KGfTyOoMIvMgZdLzTk27nc2+GMWz9sn9bTpnUbbeyjlbrzXgLAgXdRr0Zb0GgoNuoN+MtCBR0G/VmvAWBgm6j3oy3IFDQbdSb8RYECrqNejPegkBBt1FvxlsQKOg26s14CwIF3Ua9GW9BoKDbqDfjLQgUdBv1ZrwFgYJuo96MtyBQ0G3Um/EWBAq6jXoz3oJg6EEDW9MTuj4wPu+Ba8BsjaAXrWfrwGKN5218tZ6lA/ExcFMKeuhBp1+1lg64UTTkFPQscDVtDGPzDrhSZTMUERERyWvkPY16PRDdmFTogainUenWXEFX7IFo6ajUAxl5T2Oj1AMRERERERERkTAmvwDTXRw16rej9gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityimprovement);
export default __webpack_public_path__ + "static/media/Facility improvement.490f88e79507beb4871633e0e4ad6009.svg";
export { ForwardRef as ReactComponent };